import { useQuery } from "@tanstack/react-query";
import { getTargetareUniversComplet } from "@/api/endpoints/targetare";
import { queryKeys } from "@/lib/queryClient";
import type { TargetareFiltre } from "@/types/targetare";

export function useGetTargetareUniversComplet(
  filtre: TargetareFiltre,
  versiune: string | null | undefined
) {
  return useQuery({
    queryKey: queryKeys.targetare.universComplet(filtre, versiune),
    queryFn: () => getTargetareUniversComplet(filtre),
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
